import type { IModuleToggles } from "@/Store";

export const USER_TYPE_LABEL: Record<string, string> = {
  superadmin: "Super Admin",
  support: "Suporte",
  owner: "Proprietário",
  admin: "Admin",
  member: "Membro",
};

export const userTypeLabel = (type?: string | null) =>
  type ? USER_TYPE_LABEL[type] ?? type : "-";

export const MODULE_LABELS: { key: keyof IModuleToggles; label: string }[] = [
  { key: "users", label: "Usuários" },
  { key: "departments", label: "Departamentos" },
  { key: "leads", label: "Leads" },
  { key: "clients", label: "Clientes" },
  { key: "contacts", label: "Contatos" },
  { key: "projects", label: "Projetos" },
  { key: "documents", label: "Documentos" },
  { key: "subscriptions", label: "Assinantes" },
  { key: "finance", label: "Financeiro" },
  { key: "kanban", label: "Kanban" },
  { key: "employees", label: "Funcionários" },
  { key: "timeclock", label: "Jornadas de trabalho" },
];

export const moduleLabel = (key: string) =>
  MODULE_LABELS.find((module) => module.key === key)?.label ?? key;

